module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "Resources-chapter"
  }, [_vm._v("Praise for "), _c('span', {
    staticClass: "Fauxtalics"
  }, [_vm._v("Mary & Me")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“"), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Mary & Me")]), _vm._v(" is a powerful testament to the beauty of friendship as told through decades of letter writing. In a disarmingly personal depiction, Kenyon and Humston lead us through a story of friendship that withstands time, distance, and all the joy and heartache that life can offer.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_c('span', [_vm._v("—HEATHER GUDENKAUF")]), _vm._v(" "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("New York Times")]), _vm._v(" and "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("USA Today ")]), _vm._v("bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“This book is a pure tribute to friendship, letter writing, and, most of all, love. The shared experiences of loss, faith, and letting go between Mary and Mary aren’t just inspiring—they’re enough to push you out of your own comfort zone to be a little braver today. No doubt, this is the sort of story that will make you want to try harder, love people better, hold the good ones in your life tighter, and leave no collection of words left unsaid. In short, this book captures the real stuff of life. The real stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—HANNAH BRENCHER Creator of MoreLoveLetters.com, TED speaker, and author of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("If You Find This Letter ")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“Through friendship and a treasure trove of handwritten letters, "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Mary & Me")]), _vm._v(" shows how our connections to one another make life precious. Mary Potter Kenyon and Mary Jedlicka Humston have given us the gift of a heartfelt and endearing memoir that will stand the test of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—JOHN SCHLIMM Award-winning author of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Five Years in Heaven: The Unlikely Friendship That Answered Life’s Greatest Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“A book about the joy of letters is always a cause of celebration, and when it is also a book about the incomparable consolations of friendship expressed through letters, the celebration is even greater. "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Mary & Me ")]), _vm._v("offers beautiful proof that there is no better demonstration of true friendship than through letters: shared confidences that address our sorrows, our joys, and our need for each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—NINA SANKOVITCH Bestselling author of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Tolstoy and the Purple Chair")]), _vm._v(" and "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Signed, Sealed, Delivered: Celebrating the Joys of Letter Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“Mary Kenyon is one of those rare women who walked into my world and became an instant lifelong friend. She exudes love of family, faith, integrity, and beauty, and those things shine in her writing and relationships. "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Mary & Me: A Lasting Link Through Ink")]), _vm._v(", cowritten with Mary Jedlicka Humston, offers rich wisdom about the art of friendship and the beauty of commitment that goes beyond the limits of time and space. Mary and Mary show how words enrich us, give us life, and bond our spirits and souls.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—SHELLY BEACH Christy Award–winning author of twelve books and coauthor of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("Love Letters from the Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“The letter writing that conspired weekly for nearly thirty years to create this book is a model of friendship and love that makes me wish to turn back the clock and re-create this for my own life. The world would be a more beautiful place if everyone would engage with each other in the same way that the Marys have.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—WENDY WOLFF Author of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("The Letter Writing Project")])]), _vm._v(" "), _c('p', {
    staticClass: "x1st-Para-2"
  }, [_vm._v("“In this book, the two Marys focus on friendship through the written word, two topics near and dear to my heart. For twenty-five years, I have made my living as a writer, and although I love my job, it is when I put my pen to paper and write to my friends that I feel happiest. Sharing my life and inner thoughts with someone who listens, cares, and responds, even if that friend is miles away, is key to my well-being. This book is a wonderful reminder of how much we need others, and how, for many of us, that comfort, joy, and happiness comes in an envelope in the mailbox.”")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_vm._v("—TAMARA ORR Author of "), _c('span', {
    staticClass: "Italics-6"
  }, [_vm._v("A Parent’s Guide to Homeschooling ")]), _vm._v("and over 400 children’s books")]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_c('span', {
    staticClass: "Italics-6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Endorser"
  }, [_c('span', {
    staticClass: "Italics-6"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c92af8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/00_MaryMe_endorsements.vue
// module id = 57
// module chunks = 0